export enum TipoInstitucion
{
    Banco = "Banco",
    CasasComerciales = "Casas Comerciales",
    CajaCompensacion = "Caja de Compensación",
    CompaniaSeguros = "Compañía de Seguros",
    Empleador = "Empleador",
}